<template>
  <div class="header">
    <div class="title">
      <div class="blank">
        <img src="./logo.png" alt="logo" />
      </div>
    </div>
    <div id="nav">
      <input type="text" placeholder="search" />
      <router-link to="/">Home </router-link>
      <router-link to="/about">About</router-link>
      <router-link to="/cart">Cart ({{ cartQauntity }})</router-link>
      <a href="#" @click.prevent="doLogout">Logout</a>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    cartQauntity() {
      const cart = this.$store.state.cart;
      let total = 0;
      for (const item of Object.keys(cart)) {
        if (cart[item] > 0) {
          total += 1;
        }
      }
      return total;
    },
  },
  methods: {
    doLogout() {
      localStorage.removeItem("user");
    },
  },
};
</script>
<style lang="scss" scoped>
.header {
  display: grid;
  justify-content: space-between;
  align-items: center;
  grid-template-columns: 1fr 2.4fr 0.5fr;
  .title {
    $imgsizeW: 100px;
    $imgsizeH: 100px;
    .blank {
      background: #bccbdec5;
      img {
        padding-top: 10px;
        padding-left: 115px;
        height: $imgsizeH;
        min-width: $imgsizeW;
      }
    }
  }
  input {
    width: 400px;
    height: 20px;
    margin: 25px 50px;
    text-align: center;
  }
  #nav {
    justify-self: end;
  }
  #nav a{
    text-decoration: none;
    color:#2c3e50;
    padding:5px;
  }
}
</style>
